export const alertConfig = {
  PET_CREATED: {
    icon: 'success',
    textContent: 'Prontuário do pet criado com sucesso!'
  },
  PET_UPDATED: {
    icon: 'success',
    textContent: 'Os dados do pet foram atualizados com sucesso!'
  },
  CANCELED: {
    icon: 'success',
    textContent: 'O registro da consulta foi descartado com sucesso!'
  }
}

export const LIMIT = 8

export const INITIAL_CURRENT_PAGE = 1
